import { computed as E, toValue as y, unref as w, onMounted as Rt, getCurrentInstance as Oe, provide as ot, isRef as We, watch as ie, onBeforeUnmount as cn, inject as fn, onUnmounted as Bt, ref as x, reactive as qe, readonly as vn, watchEffect as mn, nextTick as ne, shallowRef as pn, warn as hn, defineComponent as yn, resolveComponent as Ce, createElementBlock as M, openBlock as P, normalizeClass as Ne, createCommentVNode as ge, createElementVNode as Ve, withDirectives as bn, createVNode as Fe, mergeProps as lt, vModelCheckbox as gn, toDisplayString as te, Fragment as kt, renderList as jt, createBlock as Vn, withCtx as On, createTextVNode as Sn, toHandlers as Et } from "vue";
import { v as kn } from "./vsIcon-Cyr63bPF.mjs";
import { v as jn } from "./vsUpload-CDWjMLUp.mjs";
import { v as En } from "./vsAvatar-SOtko3H3.mjs";
import { v as Cn } from "./vsTelInput-DDMjHdHU.mjs";
import { v as An } from "./vsButton-BlFL21k0.mjs";
import { v as wn } from "./vsCalendar-Cj3ZLH8g.mjs";
import { _ as In } from "./_plugin-vue_export-helper-CHgC5LLL.mjs";
/**
  * vee-validate v4.15.0
  * (c) 2024 Abdelrahman Awad
  * @license MIT
  */
function H(e) {
  return typeof e == "function";
}
function $t(e) {
  return e == null;
}
const ve = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function vt(e) {
  return Number(e) >= 0;
}
function _n(e) {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}
function Nn(e) {
  return typeof e == "object" && e !== null;
}
function Fn(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function Ct(e) {
  if (!Nn(e) || Fn(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Be(e, t) {
  return Object.keys(t).forEach((n) => {
    if (Ct(t[n]) && Ct(e[n])) {
      e[n] || (e[n] = {}), Be(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function Pe(e) {
  const t = e.split(".");
  if (!t.length)
    return "";
  let n = String(t[0]);
  for (let r = 1; r < t.length; r++) {
    if (vt(t[r])) {
      n += `[${t[r]}]`;
      continue;
    }
    n += `.${t[r]}`;
  }
  return n;
}
const Ut = {};
function tl(e, t) {
  Tn(e, t), Ut[e] = t;
}
function Pn(e) {
  return Ut[e];
}
function Tn(e, t) {
  if (!H(t))
    throw new Error(`Extension Error: The validator '${e}' must be a function.`);
}
function At(e, t, n) {
  typeof n.value == "object" && (n.value = C(n.value)), !n.enumerable || n.get || n.set || !n.configurable || !n.writable || t === "__proto__" ? Object.defineProperty(e, t, n) : e[t] = n.value;
}
function C(e) {
  if (typeof e != "object") return e;
  var t = 0, n, r, o, i = Object.prototype.toString.call(e);
  if (i === "[object Object]" ? o = Object.create(e.__proto__ || null) : i === "[object Array]" ? o = Array(e.length) : i === "[object Set]" ? (o = /* @__PURE__ */ new Set(), e.forEach(function(s) {
    o.add(C(s));
  })) : i === "[object Map]" ? (o = /* @__PURE__ */ new Map(), e.forEach(function(s, c) {
    o.set(C(c), C(s));
  })) : i === "[object Date]" ? o = /* @__PURE__ */ new Date(+e) : i === "[object RegExp]" ? o = new RegExp(e.source, e.flags) : i === "[object DataView]" ? o = new e.constructor(C(e.buffer)) : i === "[object ArrayBuffer]" ? o = e.slice(0) : i.slice(-6) === "Array]" && (o = new e.constructor(e)), o) {
    for (r = Object.getOwnPropertySymbols(e); t < r.length; t++)
      At(o, r[t], Object.getOwnPropertyDescriptor(e, r[t]));
    for (t = 0, r = Object.getOwnPropertyNames(e); t < r.length; t++)
      Object.hasOwnProperty.call(o, n = r[t]) && o[n] === e[n] || At(o, n, Object.getOwnPropertyDescriptor(e, n));
  }
  return o || e;
}
const mt = Symbol("vee-validate-form"), Mn = Symbol("vee-validate-form-context"), Dn = Symbol("vee-validate-field-instance"), wt = Symbol("Default empty value"), zt = typeof window < "u";
function ut(e) {
  return H(e) && !!e.__locatorRef;
}
function re(e) {
  return !!e && H(e.parse) && e.__type === "VVTypedSchema";
}
function He(e) {
  return !!e && H(e.validate);
}
function Lt(e) {
  return e === "checkbox" || e === "radio";
}
function Rn(e) {
  return ve(e) || Array.isArray(e);
}
function Bn(e) {
  return Array.isArray(e) ? e.length === 0 : ve(e) && Object.keys(e).length === 0;
}
function Ke(e) {
  return /^\[.+\]$/i.test(e);
}
function $n(e) {
  return Wt(e) && e.multiple;
}
function Wt(e) {
  return e.tagName === "SELECT";
}
function Un(e) {
  return qt(e) && e.target && "submit" in e.target;
}
function qt(e) {
  return e ? !!(typeof Event < "u" && H(Event) && e instanceof Event || e && e.srcElement) : !1;
}
function G(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!G(e[r], t[r]))
          return !1;
      return !0;
    }
    if (e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      for (r of e.entries())
        if (!G(r[1], t.get(r[0])))
          return !1;
      return !0;
    }
    if (_t(e) && _t(t))
      return !(e.size !== t.size || e.name !== t.name || e.lastModified !== t.lastModified || e.type !== t.type);
    if (e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e.entries())
        if (!t.has(r[0]))
          return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === t.toString();
    if (o = Object.keys(e), n = o.length - It(e, o), n !== Object.keys(t).length - It(t, Object.keys(t)))
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      var i = o[r];
      if (!G(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function It(e, t) {
  let n = 0;
  for (let o = t.length; o-- !== 0; ) {
    var r = t[o];
    e[r] === void 0 && n++;
  }
  return n;
}
function _t(e) {
  return zt ? e instanceof File : !1;
}
function pt(e) {
  return Ke(e) ? e.replace(/\[|\]/gi, "") : e;
}
function X(e, t, n) {
  return e ? Ke(t) ? e[pt(t)] : (t || "").split(/\.|\[(\d+)\]/).filter(Boolean).reduce((o, i) => Rn(o) && i in o ? o[i] : n, e) : n;
}
function ae(e, t, n) {
  if (Ke(t)) {
    e[pt(t)] = n;
    return;
  }
  const r = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let o = e;
  for (let i = 0; i < r.length; i++) {
    if (i === r.length - 1) {
      o[r[i]] = n;
      return;
    }
    (!(r[i] in o) || $t(o[r[i]])) && (o[r[i]] = vt(r[i + 1]) ? [] : {}), o = o[r[i]];
  }
}
function at(e, t) {
  if (Array.isArray(e) && vt(t)) {
    e.splice(Number(t), 1);
    return;
  }
  ve(e) && delete e[t];
}
function Nt(e, t) {
  if (Ke(t)) {
    delete e[pt(t)];
    return;
  }
  const n = t.split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = e;
  for (let i = 0; i < n.length; i++) {
    if (i === n.length - 1) {
      at(r, n[i]);
      break;
    }
    if (!(n[i] in r) || $t(r[n[i]]))
      break;
    r = r[n[i]];
  }
  const o = n.map((i, s) => X(e, n.slice(0, s).join(".")));
  for (let i = o.length - 1; i >= 0; i--)
    if (Bn(o[i])) {
      if (i === 0) {
        at(e, n[0]);
        continue;
      }
      at(o[i - 1], n[i - 1]);
    }
}
function Y(e) {
  return Object.keys(e);
}
function Ht(e, t = void 0) {
  const n = Oe();
  return (n == null ? void 0 : n.provides[e]) || fn(e, t);
}
function Ft(e, t, n) {
  if (Array.isArray(e)) {
    const r = [...e], o = r.findIndex((i) => G(i, t));
    return o >= 0 ? r.splice(o, 1) : r.push(t), r;
  }
  return G(e, t) ? n : t;
}
function zn(e, t) {
  let n, r;
  return function(...o) {
    const i = this;
    return n || (n = !0, setTimeout(() => n = !1, t), r = e.apply(i, o)), r;
  };
}
function Pt(e, t = 0) {
  let n = null, r = [];
  return function(...o) {
    return n && clearTimeout(n), n = setTimeout(() => {
      const i = e(...o);
      r.forEach((s) => s(i)), r = [];
    }, t), new Promise((i) => r.push(i));
  };
}
function Ln(e, t) {
  return ve(t) && t.number ? _n(e) : e;
}
function st(e, t) {
  let n;
  return async function(...o) {
    const i = e(...o);
    n = i;
    const s = await i;
    return i !== n ? s : (n = void 0, t(s, o));
  };
}
function dt(e) {
  return Array.isArray(e) ? e : e ? [e] : [];
}
function ze(e, t) {
  const n = {};
  for (const r in e)
    t.includes(r) || (n[r] = e[r]);
  return n;
}
function Wn(e) {
  let t = null, n = [];
  return function(...r) {
    const o = ne(() => {
      if (t !== o)
        return;
      const i = e(...r);
      n.forEach((s) => s(i)), n = [], t = null;
    });
    return t = o, new Promise((i) => n.push(i));
  };
}
function it(e) {
  if (Gt(e))
    return e._value;
}
function Gt(e) {
  return "_value" in e;
}
function qn(e) {
  return e.type === "number" || e.type === "range" ? Number.isNaN(e.valueAsNumber) ? e.value : e.valueAsNumber : e.value;
}
function Ge(e) {
  if (!qt(e))
    return e;
  const t = e.target;
  if (Lt(t.type) && Gt(t))
    return it(t);
  if (t.type === "file" && t.files) {
    const n = Array.from(t.files);
    return t.multiple ? n : n[0];
  }
  if ($n(t))
    return Array.from(t.options).filter((n) => n.selected && !n.disabled).map(it);
  if (Wt(t)) {
    const n = Array.from(t.options).find((r) => r.selected);
    return n ? it(n) : t.value;
  }
  return qn(t);
}
function Kt(e) {
  const t = {};
  return Object.defineProperty(t, "_$$isNormalized", {
    value: !0,
    writable: !1,
    enumerable: !1,
    configurable: !1
  }), e ? ve(e) && e._$$isNormalized ? e : ve(e) ? Object.keys(e).reduce((n, r) => {
    const o = Hn(e[r]);
    return e[r] !== !1 && (n[r] = Tt(o)), n;
  }, t) : typeof e != "string" ? t : e.split("|").reduce((n, r) => {
    const o = Gn(r);
    return o.name && (n[o.name] = Tt(o.params)), n;
  }, t) : t;
}
function Hn(e) {
  return e === !0 ? [] : Array.isArray(e) || ve(e) ? e : [e];
}
function Tt(e) {
  const t = (n) => typeof n == "string" && n[0] === "@" ? Kn(n.slice(1)) : n;
  return Array.isArray(e) ? e.map(t) : e instanceof RegExp ? [e] : Object.keys(e).reduce((n, r) => (n[r] = t(e[r]), n), {});
}
const Gn = (e) => {
  let t = [];
  const n = e.split(":")[0];
  return e.includes(":") && (t = e.split(":").slice(1).join(":").split(",")), { name: n, params: t };
};
function Kn(e) {
  const t = (n) => {
    var r;
    return (r = X(n, e)) !== null && r !== void 0 ? r : n[e];
  };
  return t.__locatorRef = e, t;
}
function Yn(e) {
  return Array.isArray(e) ? e.filter(ut) : Y(e).filter((t) => ut(e[t])).map((t) => e[t]);
}
const Jn = {
  generateMessage: ({ field: e }) => `${e} is not valid.`,
  bails: !0,
  validateOnBlur: !0,
  validateOnChange: !0,
  validateOnInput: !1,
  validateOnModelUpdate: !0
};
let ct = Object.assign({}, Jn);
const Te = () => ct, Xn = (e) => {
  ct = Object.assign(Object.assign({}, ct), e);
}, nl = Xn;
async function Yt(e, t, n = {}) {
  const r = n == null ? void 0 : n.bails, o = {
    name: (n == null ? void 0 : n.name) || "{field}",
    rules: t,
    label: n == null ? void 0 : n.label,
    bails: r ?? !0,
    formData: (n == null ? void 0 : n.values) || {}
  }, i = await xn(o, e);
  return Object.assign(Object.assign({}, i), { valid: !i.errors.length });
}
async function xn(e, t) {
  const n = e.rules;
  if (re(n) || He(n))
    return Zn(t, Object.assign(Object.assign({}, e), { rules: n }));
  if (H(n) || Array.isArray(n)) {
    const c = {
      field: e.label || e.name,
      name: e.name,
      label: e.label,
      form: e.formData,
      value: t
    }, v = Array.isArray(n) ? n : [n], d = v.length, m = [];
    for (let O = 0; O < d; O++) {
      const p = v[O], S = await p(t, c);
      if (!(typeof S != "string" && !Array.isArray(S) && S)) {
        if (Array.isArray(S))
          m.push(...S);
        else {
          const B = typeof S == "string" ? S : Xt(c);
          m.push(B);
        }
        if (e.bails)
          return {
            errors: m
          };
      }
    }
    return {
      errors: m
    };
  }
  const r = Object.assign(Object.assign({}, e), { rules: Kt(n) }), o = [], i = Object.keys(r.rules), s = i.length;
  for (let c = 0; c < s; c++) {
    const v = i[c], d = await er(r, t, {
      name: v,
      params: r.rules[v]
    });
    if (d.error && (o.push(d.error), e.bails))
      return {
        errors: o
      };
  }
  return {
    errors: o
  };
}
function Qn(e) {
  return !!e && e.name === "ValidationError";
}
function Jt(e) {
  return {
    __type: "VVTypedSchema",
    async parse(n, r) {
      var o;
      try {
        return {
          output: await e.validate(n, { abortEarly: !1, context: (r == null ? void 0 : r.formData) || {} }),
          errors: []
        };
      } catch (i) {
        if (!Qn(i))
          throw i;
        if (!(!((o = i.inner) === null || o === void 0) && o.length) && i.errors.length)
          return { errors: [{ path: i.path, errors: i.errors }] };
        const s = i.inner.reduce((c, v) => {
          const d = v.path || "";
          return c[d] || (c[d] = { errors: [], path: d }), c[d].errors.push(...v.errors), c;
        }, {});
        return { errors: Object.values(s) };
      }
    }
  };
}
async function Zn(e, t) {
  const r = await (re(t.rules) ? t.rules : Jt(t.rules)).parse(e, { formData: t.formData }), o = [];
  for (const i of r.errors)
    i.errors.length && o.push(...i.errors);
  return {
    value: r.value,
    errors: o
  };
}
async function er(e, t, n) {
  const r = Pn(n.name);
  if (!r)
    throw new Error(`No such validator '${n.name}' exists.`);
  const o = tr(n.params, e.formData), i = {
    field: e.label || e.name,
    name: e.name,
    label: e.label,
    value: t,
    form: e.formData,
    rule: Object.assign(Object.assign({}, n), { params: o })
  }, s = await r(t, o, i);
  return typeof s == "string" ? {
    error: s
  } : {
    error: s ? void 0 : Xt(i)
  };
}
function Xt(e) {
  const t = Te().generateMessage;
  return t ? t(e) : "Field is invalid";
}
function tr(e, t) {
  const n = (r) => ut(r) ? r(t) : r;
  return Array.isArray(e) ? e.map(n) : Object.keys(e).reduce((r, o) => (r[o] = n(e[o]), r), {});
}
async function nr(e, t) {
  const r = await (re(e) ? e : Jt(e)).parse(C(t), { formData: C(t) }), o = {}, i = {};
  for (const s of r.errors) {
    const c = s.errors, v = (s.path || "").replace(/\["(\d+)"\]/g, (d, m) => `[${m}]`);
    o[v] = { valid: !c.length, errors: c }, c.length && (i[v] = c[0]);
  }
  return {
    valid: !r.errors.length,
    results: o,
    errors: i,
    values: r.value,
    source: "schema"
  };
}
async function rr(e, t, n) {
  const o = Y(e).map(async (d) => {
    var m, O, p;
    const S = (m = n == null ? void 0 : n.names) === null || m === void 0 ? void 0 : m[d], N = await Yt(X(t, d), e[d], {
      name: (S == null ? void 0 : S.name) || d,
      label: S == null ? void 0 : S.label,
      values: t,
      bails: (p = (O = n == null ? void 0 : n.bailsMap) === null || O === void 0 ? void 0 : O[d]) !== null && p !== void 0 ? p : !0
    });
    return Object.assign(Object.assign({}, N), { path: d });
  });
  let i = !0;
  const s = await Promise.all(o), c = {}, v = {};
  for (const d of s)
    c[d.path] = {
      valid: d.valid,
      errors: d.errors
    }, d.valid || (i = !1, v[d.path] = d.errors[0]);
  return {
    valid: i,
    results: c,
    errors: v,
    source: "schema"
  };
}
let Mt = 0;
function lr(e, t) {
  const { value: n, initialValue: r, setInitialValue: o } = ar(e, t.modelValue, t.form);
  if (!t.form) {
    let p = function(S) {
      var N;
      "value" in S && (n.value = S.value), "errors" in S && d(S.errors), "touched" in S && (O.touched = (N = S.touched) !== null && N !== void 0 ? N : O.touched), "initialValue" in S && o(S.initialValue);
    };
    const { errors: v, setErrors: d } = ur(), m = Mt >= Number.MAX_SAFE_INTEGER ? 0 : ++Mt, O = or(n, r, v, t.schema);
    return {
      id: m,
      path: e,
      value: n,
      initialValue: r,
      meta: O,
      flags: { pendingUnmount: { [m]: !1 }, pendingReset: !1 },
      errors: v,
      setState: p
    };
  }
  const i = t.form.createPathState(e, {
    bails: t.bails,
    label: t.label,
    type: t.type,
    validate: t.validate,
    schema: t.schema
  }), s = E(() => i.errors);
  function c(v) {
    var d, m, O;
    "value" in v && (n.value = v.value), "errors" in v && ((d = t.form) === null || d === void 0 || d.setFieldError(w(e), v.errors)), "touched" in v && ((m = t.form) === null || m === void 0 || m.setFieldTouched(w(e), (O = v.touched) !== null && O !== void 0 ? O : !1)), "initialValue" in v && o(v.initialValue);
  }
  return {
    id: Array.isArray(i.id) ? i.id[i.id.length - 1] : i.id,
    path: e,
    value: n,
    errors: s,
    meta: i,
    initialValue: r,
    flags: i.__flags,
    setState: c
  };
}
function ar(e, t, n) {
  const r = x(w(t));
  function o() {
    return n ? X(n.initialValues.value, w(e), w(r)) : w(r);
  }
  function i(d) {
    if (!n) {
      r.value = d;
      return;
    }
    n.setFieldInitialValue(w(e), d, !0);
  }
  const s = E(o);
  if (!n)
    return {
      value: x(o()),
      initialValue: s,
      setInitialValue: i
    };
  const c = ir(t, n, s, e);
  return n.stageInitialValue(w(e), c, !0), {
    value: E({
      get() {
        return X(n.values, w(e));
      },
      set(d) {
        n.setFieldValue(w(e), d, !1);
      }
    }),
    initialValue: s,
    setInitialValue: i
  };
}
function ir(e, t, n, r) {
  return We(e) ? w(e) : e !== void 0 ? e : X(t.values, w(r), w(n));
}
function or(e, t, n, r) {
  const o = E(() => {
    var s, c, v;
    return (v = (c = (s = y(r)) === null || s === void 0 ? void 0 : s.describe) === null || c === void 0 ? void 0 : c.call(s).required) !== null && v !== void 0 ? v : !1;
  }), i = qe({
    touched: !1,
    pending: !1,
    valid: !0,
    required: o,
    validated: !!w(n).length,
    initialValue: E(() => w(t)),
    dirty: E(() => !G(w(e), w(t)))
  });
  return ie(n, (s) => {
    i.valid = !s.length;
  }, {
    immediate: !0,
    flush: "sync"
  }), i;
}
function ur() {
  const e = x([]);
  return {
    errors: e,
    setErrors: (t) => {
      e.value = dt(t);
    }
  };
}
const Me = {}, De = {}, Re = "vee-validate-inspector", J = {
  error: 12405579,
  success: 448379,
  unknown: 5522283,
  white: 16777215,
  black: 0,
  blue: 218007,
  purple: 12157168,
  orange: 16099682,
  gray: 12304330
};
let D = null, ue;
async function xt(e) {
  if (process.env.NODE_ENV !== "production") {
    if (!zt)
      return;
    (await import("./index-BbGUveIH.mjs")).setupDevtoolsPlugin({
      id: "vee-validate-devtools-plugin",
      label: "VeeValidate Plugin",
      packageName: "vee-validate",
      homepage: "https://vee-validate.logaretm.com/v4",
      app: e,
      logo: "https://vee-validate.logaretm.com/v4/logo.png"
    }, (n) => {
      ue = n, n.addInspector({
        id: Re,
        icon: "rule",
        label: "vee-validate",
        noSelectionText: "Select a vee-validate node to inspect",
        actions: [
          {
            icon: "done_outline",
            tooltip: "Validate selected item",
            action: async () => {
              if (!D) {
                console.error("There is not a valid selected vee-validate node or component");
                return;
              }
              if (D.type === "field") {
                await D.field.validate();
                return;
              }
              if (D.type === "form") {
                await D.form.validate();
                return;
              }
              D.type === "pathState" && await D.form.validateField(D.state.path);
            }
          },
          {
            icon: "delete_sweep",
            tooltip: "Clear validation state of the selected item",
            action: () => {
              if (!D) {
                console.error("There is not a valid selected vee-validate node or component");
                return;
              }
              if (D.type === "field") {
                D.field.resetField();
                return;
              }
              D.type === "form" && D.form.resetForm(), D.type === "pathState" && D.form.resetField(D.state.path);
            }
          }
        ]
      }), n.on.getInspectorTree((r) => {
        if (r.inspectorId !== Re)
          return;
        const o = Object.values(Me), i = Object.values(De);
        r.rootNodes = [
          ...o.map(cr),
          ...i.map((s) => vr(s))
        ];
      }), n.on.getInspectorState((r) => {
        if (r.inspectorId !== Re)
          return;
        const { form: o, field: i, state: s, type: c } = mr(r.nodeId);
        if (n.unhighlightElement(), o && c === "form") {
          r.state = pr(o), D = { type: "form", form: o }, n.highlightElement(o._vm);
          return;
        }
        if (s && c === "pathState" && o) {
          r.state = Dt(s), D = { type: "pathState", state: s, form: o };
          return;
        }
        if (i && c === "field") {
          r.state = Dt({
            errors: i.errors.value,
            dirty: i.meta.dirty,
            valid: i.meta.valid,
            touched: i.meta.touched,
            value: i.value.value,
            initialValue: i.meta.initialValue
          }), D = { field: i, type: "field" }, n.highlightElement(i._vm);
          return;
        }
        D = null, n.unhighlightElement();
      });
    });
  }
}
const Ae = zn(() => {
  setTimeout(async () => {
    await ne(), ue == null || ue.sendInspectorState(Re), ue == null || ue.sendInspectorTree(Re);
  }, 100);
}, 100);
function sr(e) {
  const t = Oe();
  if (!ue) {
    const n = t == null ? void 0 : t.appContext.app;
    if (!n)
      return;
    xt(n);
  }
  Me[e.formId] = Object.assign({}, e), Me[e.formId]._vm = t, Bt(() => {
    delete Me[e.formId], Ae();
  }), Ae();
}
function dr(e) {
  const t = Oe();
  if (!ue) {
    const n = t == null ? void 0 : t.appContext.app;
    if (!n)
      return;
    xt(n);
  }
  De[e.id] = Object.assign({}, e), De[e.id]._vm = t, Bt(() => {
    delete De[e.id], Ae();
  }), Ae();
}
function cr(e) {
  const { textColor: t, bgColor: n } = Zt(e.meta.value.valid), r = {};
  Object.values(e.getAllPathStates()).forEach((s) => {
    ae(r, y(s.path), fr(s, e));
  });
  function o(s, c = []) {
    const v = [...c].pop();
    return "id" in s ? Object.assign(Object.assign({}, s), { label: v || s.label }) : ve(s) ? {
      id: `${c.join(".")}`,
      label: v || "",
      children: Object.keys(s).map((d) => o(s[d], [...c, d]))
    } : Array.isArray(s) ? {
      id: `${c.join(".")}`,
      label: `${v}[]`,
      children: s.map((d, m) => o(d, [...c, String(m)]))
    } : { id: "", label: "", children: [] };
  }
  const { children: i } = o(r);
  return {
    id: ht(e),
    label: e.name,
    children: i,
    tags: [
      {
        label: "Form",
        textColor: t,
        backgroundColor: n
      },
      {
        label: `${e.getAllPathStates().length} fields`,
        textColor: J.white,
        backgroundColor: J.unknown
      }
    ]
  };
}
function fr(e, t) {
  return {
    id: ht(t, e),
    label: y(e.path),
    tags: Qt(e.multiple, e.fieldsCount, e.type, e.valid, t)
  };
}
function vr(e, t) {
  return {
    id: ht(t, e),
    label: w(e.name),
    tags: Qt(!1, 1, e.type, e.meta.valid, t)
  };
}
function Qt(e, t, n, r, o) {
  const { textColor: i, bgColor: s } = Zt(r);
  return [
    e ? void 0 : {
      label: "Field",
      textColor: i,
      backgroundColor: s
    },
    o ? void 0 : {
      label: "Standalone",
      textColor: J.black,
      backgroundColor: J.gray
    },
    n === "checkbox" ? {
      label: "Checkbox",
      textColor: J.white,
      backgroundColor: J.blue
    } : void 0,
    n === "radio" ? {
      label: "Radio",
      textColor: J.white,
      backgroundColor: J.purple
    } : void 0,
    e ? {
      label: "Multiple",
      textColor: J.black,
      backgroundColor: J.orange
    } : void 0
  ].filter(Boolean);
}
function ht(e, t) {
  const n = t ? "path" in t ? "pathState" : "field" : "form", r = t ? "path" in t ? t == null ? void 0 : t.path : y(t == null ? void 0 : t.name) : "", o = { f: e == null ? void 0 : e.formId, ff: (t == null ? void 0 : t.id) || r, type: n };
  return btoa(encodeURIComponent(JSON.stringify(o)));
}
function mr(e) {
  try {
    const t = JSON.parse(decodeURIComponent(atob(e))), n = Me[t.f];
    if (!n && t.ff) {
      const o = De[t.ff];
      return o ? {
        type: t.type,
        field: o
      } : {};
    }
    if (!n)
      return {};
    const r = n.getPathState(t.ff);
    return {
      type: t.type,
      form: n,
      state: r
    };
  } catch {
  }
  return {};
}
function Dt(e) {
  return {
    "Field state": [
      { key: "errors", value: e.errors },
      {
        key: "initialValue",
        value: e.initialValue
      },
      {
        key: "currentValue",
        value: e.value
      },
      {
        key: "touched",
        value: e.touched
      },
      {
        key: "dirty",
        value: e.dirty
      },
      {
        key: "valid",
        value: e.valid
      }
    ]
  };
}
function pr(e) {
  const { errorBag: t, meta: n, values: r, isSubmitting: o, isValidating: i, submitCount: s } = e;
  return {
    "Form state": [
      {
        key: "submitCount",
        value: s.value
      },
      {
        key: "isSubmitting",
        value: o.value
      },
      {
        key: "isValidating",
        value: i.value
      },
      {
        key: "touched",
        value: n.value.touched
      },
      {
        key: "dirty",
        value: n.value.dirty
      },
      {
        key: "valid",
        value: n.value.valid
      },
      {
        key: "initialValues",
        value: n.value.initialValues
      },
      {
        key: "currentValues",
        value: r
      },
      {
        key: "errors",
        value: Y(t.value).reduce((c, v) => {
          var d;
          const m = (d = t.value[v]) === null || d === void 0 ? void 0 : d[0];
          return m && (c[v] = m), c;
        }, {})
      }
    ]
  };
}
function Zt(e) {
  return {
    bgColor: e ? J.success : J.error,
    textColor: e ? J.black : J.white
  };
}
function hr(e, t, n) {
  return Lt(n == null ? void 0 : n.type) ? br(e, t, n) : en(e, t, n);
}
function en(e, t, n) {
  const { initialValue: r, validateOnMount: o, bails: i, type: s, checkedValue: c, label: v, validateOnValueUpdate: d, uncheckedValue: m, controlled: O, keepValueOnUnmount: p, syncVModel: S, form: N } = yr(n), B = O ? Ht(mt) : void 0, b = N || B, $ = E(() => Pe(y(e))), U = E(() => {
    if (y(b == null ? void 0 : b.schema))
      return;
    const k = w(t);
    return He(k) || re(k) || H(k) || Array.isArray(k) ? k : Kt(k);
  }), Ye = !H(U.value) && re(y(t)), { id: Se, value: me, initialValue: pe, meta: R, setState: ke, errors: je, flags: he } = lr($, {
    modelValue: r,
    form: b,
    bails: i,
    label: v,
    type: s,
    validate: U.value ? ce : void 0,
    schema: Ye ? t : void 0
  }), ee = E(() => je.value[0]);
  S && gr({
    value: me,
    prop: S,
    handleChange: z,
    shouldValidate: () => d && !he.pendingReset
  });
  const Ee = (h, k = !1) => {
    R.touched = !0, k && se();
  };
  async function $e(h) {
    var k, I;
    if (b != null && b.validateSchema) {
      const { results: A } = await b.validateSchema(h);
      return (k = A[y($)]) !== null && k !== void 0 ? k : { valid: !0, errors: [] };
    }
    return U.value ? Yt(me.value, U.value, {
      name: y($),
      label: y(v),
      values: (I = b == null ? void 0 : b.values) !== null && I !== void 0 ? I : {},
      bails: i
    }) : { valid: !0, errors: [] };
  }
  const se = st(async () => (R.pending = !0, R.validated = !0, $e("validated-only")), (h) => (he.pendingUnmount[L.id] || (ke({ errors: h.errors }), R.pending = !1, R.valid = h.valid), h)), de = st(async () => $e("silent"), (h) => (R.valid = h.valid, h));
  function ce(h) {
    return (h == null ? void 0 : h.mode) === "silent" ? de() : se();
  }
  function z(h, k = !0) {
    const I = Ge(h);
    we(I, k);
  }
  Rt(() => {
    if (o)
      return se();
    (!b || !b.validateSchema) && de();
  });
  function Je(h) {
    R.touched = h;
  }
  function fe(h) {
    var k;
    const I = h && "value" in h ? h.value : pe.value;
    ke({
      value: C(I),
      initialValue: C(I),
      touched: (k = h == null ? void 0 : h.touched) !== null && k !== void 0 ? k : !1,
      errors: (h == null ? void 0 : h.errors) || []
    }), R.pending = !1, R.validated = !1, de();
  }
  const ye = Oe();
  function we(h, k = !0) {
    me.value = ye && S ? Ln(h, ye.props.modelModifiers) : h, (k ? se : de)();
  }
  function Ue(h) {
    ke({ errors: Array.isArray(h) ? h : [h] });
  }
  const yt = E({
    get() {
      return me.value;
    },
    set(h) {
      we(h, d);
    }
  }), L = {
    id: Se,
    name: $,
    label: v,
    value: yt,
    meta: R,
    errors: je,
    errorMessage: ee,
    type: s,
    checkedValue: c,
    uncheckedValue: m,
    bails: i,
    keepValueOnUnmount: p,
    resetField: fe,
    handleReset: () => fe(),
    validate: ce,
    handleChange: z,
    handleBlur: Ee,
    setState: ke,
    setTouched: Je,
    setErrors: Ue,
    setValue: we
  };
  if (ot(Dn, L), We(t) && typeof w(t) != "function" && ie(t, (h, k) => {
    G(h, k) || (R.validated ? se() : de());
  }, {
    deep: !0
  }), process.env.NODE_ENV !== "production" && (L._vm = Oe(), ie(() => Object.assign(Object.assign({ errors: je.value }, R), { value: me.value }), Ae, {
    deep: !0
  }), b || dr(L)), !b)
    return L;
  const Xe = E(() => {
    const h = U.value;
    return !h || H(h) || He(h) || re(h) || Array.isArray(h) ? {} : Object.keys(h).reduce((k, I) => {
      const A = Yn(h[I]).map((oe) => oe.__locatorRef).reduce((oe, le) => {
        const Q = X(b.values, le) || b.values[le];
        return Q !== void 0 && (oe[le] = Q), oe;
      }, {});
      return Object.assign(k, A), k;
    }, {});
  });
  return ie(Xe, (h, k) => {
    if (!Object.keys(h).length)
      return;
    !G(h, k) && (R.validated ? se() : de());
  }), cn(() => {
    var h;
    const k = (h = y(L.keepValueOnUnmount)) !== null && h !== void 0 ? h : y(b.keepValuesOnUnmount), I = y($);
    if (k || !b || he.pendingUnmount[L.id]) {
      b == null || b.removePathState(I, Se);
      return;
    }
    he.pendingUnmount[L.id] = !0;
    const A = b.getPathState(I);
    if (Array.isArray(A == null ? void 0 : A.id) && (A != null && A.multiple) ? A != null && A.id.includes(L.id) : (A == null ? void 0 : A.id) === L.id) {
      if (A != null && A.multiple && Array.isArray(A.value)) {
        const le = A.value.findIndex((Q) => G(Q, y(L.checkedValue)));
        if (le > -1) {
          const Q = [...A.value];
          Q.splice(le, 1), b.setFieldValue(I, Q);
        }
        Array.isArray(A.id) && A.id.splice(A.id.indexOf(L.id), 1);
      } else
        b.unsetPathValue(y($));
      b.removePathState(I, Se);
    }
  }), L;
}
function yr(e) {
  const t = () => ({
    initialValue: void 0,
    validateOnMount: !1,
    bails: !0,
    label: void 0,
    validateOnValueUpdate: !0,
    keepValueOnUnmount: void 0,
    syncVModel: !1,
    controlled: !0
  }), n = !!(e != null && e.syncVModel), r = typeof (e == null ? void 0 : e.syncVModel) == "string" ? e.syncVModel : (e == null ? void 0 : e.modelPropName) || "modelValue", o = n && !("initialValue" in (e || {})) ? ft(Oe(), r) : e == null ? void 0 : e.initialValue;
  if (!e)
    return Object.assign(Object.assign({}, t()), { initialValue: o });
  const i = "valueProp" in e ? e.valueProp : e.checkedValue, s = "standalone" in e ? !e.standalone : e.controlled, c = (e == null ? void 0 : e.modelPropName) || (e == null ? void 0 : e.syncVModel) || !1;
  return Object.assign(Object.assign(Object.assign({}, t()), e || {}), {
    initialValue: o,
    controlled: s ?? !0,
    checkedValue: i,
    syncVModel: c
  });
}
function br(e, t, n) {
  const r = n != null && n.standalone ? void 0 : Ht(mt), o = n == null ? void 0 : n.checkedValue, i = n == null ? void 0 : n.uncheckedValue;
  function s(c) {
    const v = c.handleChange, d = E(() => {
      const O = y(c.value), p = y(o);
      return Array.isArray(O) ? O.findIndex((S) => G(S, p)) >= 0 : G(p, O);
    });
    function m(O, p = !0) {
      var S, N;
      if (d.value === ((S = O == null ? void 0 : O.target) === null || S === void 0 ? void 0 : S.checked)) {
        p && c.validate();
        return;
      }
      const B = y(e), b = r == null ? void 0 : r.getPathState(B), $ = Ge(O);
      let U = (N = y(o)) !== null && N !== void 0 ? N : $;
      r && (b != null && b.multiple) && b.type === "checkbox" ? U = Ft(X(r.values, B) || [], U, void 0) : (n == null ? void 0 : n.type) === "checkbox" && (U = Ft(y(c.value), U, y(i))), v(U, p);
    }
    return Object.assign(Object.assign({}, c), {
      checked: d,
      checkedValue: o,
      uncheckedValue: i,
      handleChange: m
    });
  }
  return s(en(e, t, n));
}
function gr({ prop: e, value: t, handleChange: n, shouldValidate: r }) {
  const o = Oe();
  if (!o || !e) {
    process.env.NODE_ENV !== "production" && console.warn("Failed to setup model events because `useField` was not called in setup.");
    return;
  }
  const i = typeof e == "string" ? e : "modelValue", s = `update:${i}`;
  i in o.props && (ie(t, (c) => {
    G(c, ft(o, i)) || o.emit(s, c);
  }), ie(() => ft(o, i), (c) => {
    if (c === wt && t.value === void 0)
      return;
    const v = c === wt ? void 0 : c;
    G(v, t.value) || n(v, r());
  }));
}
function ft(e, t) {
  if (e)
    return e.props[t];
}
let Vr = 0;
const Le = ["bails", "fieldsCount", "id", "multiple", "type", "validate"];
function tn(e) {
  const n = Object.assign({}, y({})), r = w(void 0);
  return r && re(r) && H(r.cast) ? C(r.cast(n) || {}) : C(n);
}
function rl(e) {
  var t;
  const n = Vr++, r = "Form";
  let o = 0;
  const i = x(!1), s = x(!1), c = x(0), v = [], d = qe(tn()), m = x([]), O = x({}), p = x({}), S = Wn(() => {
    p.value = m.value.reduce((a, l) => (a[Pe(y(l.path))] = l, a), {});
  });
  function N(a, l) {
    const u = z(a);
    if (!u) {
      typeof a == "string" && (O.value[Pe(a)] = dt(l));
      return;
    }
    if (typeof a == "string") {
      const f = Pe(a);
      O.value[f] && delete O.value[f];
    }
    u.errors = dt(l), u.valid = !u.errors.length;
  }
  function B(a) {
    Y(a).forEach((l) => {
      N(l, a[l]);
    });
  }
  const b = E(() => {
    const a = m.value.reduce((l, u) => (u.errors.length && (l[y(u.path)] = u.errors), l), {});
    return Object.assign(Object.assign({}, O.value), a);
  }), $ = E(() => Y(b.value).reduce((a, l) => {
    const u = b.value[l];
    return u != null && u.length && (a[l] = u[0]), a;
  }, {})), U = E(() => m.value.reduce((a, l) => (a[y(l.path)] = { name: y(l.path) || "", label: l.label || "" }, a), {})), Ye = E(() => m.value.reduce((a, l) => {
    var u;
    return a[y(l.path)] = (u = l.bails) !== null && u !== void 0 ? u : !0, a;
  }, {})), Se = Object.assign({}, {}), me = (t = void 0) !== null && t !== void 0 ? t : !1, { initialValues: pe, originalInitialValues: R, setInitialValues: ke } = Sr(m, d), je = Or(m, d, R, $), he = E(() => m.value.reduce((a, l) => {
    const u = X(d, y(l.path));
    return ae(a, y(l.path), u), a;
  }, {})), ee = void 0;
  function Ee(a, l) {
    var u, f;
    const V = E(() => X(pe.value, y(a))), j = p.value[y(a)], g = (l == null ? void 0 : l.type) === "checkbox" || (l == null ? void 0 : l.type) === "radio";
    if (j && g) {
      j.multiple = !0;
      const Z = o++;
      return Array.isArray(j.id) ? j.id.push(Z) : j.id = [j.id, Z], j.fieldsCount++, j.__flags.pendingUnmount[Z] = !1, j;
    }
    const F = E(() => X(d, y(a))), T = y(a), W = fe.findIndex((Z) => Z === T);
    W !== -1 && fe.splice(W, 1);
    const _ = E(() => {
      var Z, _e, et, tt;
      const nt = y(ee);
      if (re(nt))
        return (_e = (Z = nt.describe) === null || Z === void 0 ? void 0 : Z.call(nt, y(a)).required) !== null && _e !== void 0 ? _e : !1;
      const rt = y(l == null ? void 0 : l.schema);
      return re(rt) && (tt = (et = rt.describe) === null || et === void 0 ? void 0 : et.call(rt).required) !== null && tt !== void 0 ? tt : !1;
    }), q = o++, K = qe({
      id: q,
      path: a,
      touched: !1,
      pending: !1,
      valid: !0,
      validated: !!(!((u = Se[T]) === null || u === void 0) && u.length),
      required: _,
      initialValue: V,
      errors: pn([]),
      bails: (f = l == null ? void 0 : l.bails) !== null && f !== void 0 ? f : !1,
      label: l == null ? void 0 : l.label,
      type: (l == null ? void 0 : l.type) || "default",
      value: F,
      multiple: !1,
      __flags: {
        pendingUnmount: { [q]: !1 },
        pendingReset: !1
      },
      fieldsCount: 1,
      validate: l == null ? void 0 : l.validate,
      dirty: E(() => !G(w(F), w(V)))
    });
    return m.value.push(K), p.value[T] = K, S(), $.value[T] && !Se[T] && ne(() => {
      be(T, { mode: "silent" });
    }), We(a) && ie(a, (Z) => {
      S();
      const _e = C(F.value);
      p.value[Z] = K, ne(() => {
        ae(d, Z, _e);
      });
    }), K;
  }
  const $e = Pt(Ot, 5), se = Pt(Ot, 5), de = st(async (a) => await (a === "silent" ? $e() : se()), (a, [l]) => {
    const u = Y(k.errorBag.value), V = [
      .../* @__PURE__ */ new Set([...Y(a.results), ...m.value.map((j) => j.path), ...u])
    ].sort().reduce((j, g) => {
      var F;
      const T = g, W = z(T) || Je(T), _ = ((F = a.results[T]) === null || F === void 0 ? void 0 : F.errors) || [], q = y(W == null ? void 0 : W.path) || T, K = kr({ errors: _, valid: !_.length }, j.results[q]);
      return j.results[q] = K, K.valid || (j.errors[q] = K.errors[0]), W && O.value[q] && delete O.value[q], W ? (W.valid = K.valid, l === "silent" || l === "validated-only" && !W.validated || N(W, K.errors), j) : (N(q, _), j);
    }, {
      valid: a.valid,
      results: {},
      errors: {},
      source: a.source
    });
    return a.values && (V.values = a.values, V.source = a.source), Y(V.results).forEach((j) => {
      var g;
      const F = z(j);
      F && l !== "silent" && (l === "validated-only" && !F.validated || N(F, (g = V.results[j]) === null || g === void 0 ? void 0 : g.errors));
    }), V;
  });
  function ce(a) {
    m.value.forEach(a);
  }
  function z(a) {
    const l = typeof a == "string" ? Pe(a) : a;
    return typeof l == "string" ? p.value[l] : l;
  }
  function Je(a) {
    return m.value.filter((u) => a.startsWith(y(u.path))).reduce((u, f) => u ? f.path.length > u.path.length ? f : u : f, void 0);
  }
  let fe = [], ye;
  function we(a) {
    return fe.push(a), ye || (ye = ne(() => {
      [...fe].sort().reverse().forEach((u) => {
        Nt(d, u);
      }), fe = [], ye = null;
    })), ye;
  }
  function Ue(a) {
    return function(u, f) {
      return function(j) {
        return j instanceof Event && (j.preventDefault(), j.stopPropagation()), ce((g) => g.touched = !0), i.value = !0, c.value++, Ie().then((g) => {
          const F = C(d);
          if (g.valid && typeof u == "function") {
            const T = C(he.value);
            let W = a ? T : F;
            return g.values && (W = g.source === "schema" ? g.values : Object.assign({}, W, g.values)), u(W, {
              evt: j,
              controlledValues: T,
              setErrors: B,
              setFieldError: N,
              setTouched: bt,
              setFieldTouched: Q,
              setValues: oe,
              setFieldValue: I,
              resetForm: xe,
              resetField: gt
            });
          }
          !g.valid && typeof f == "function" && f({
            values: F,
            evt: j,
            errors: g.errors,
            results: g.results
          });
        }).then((g) => (i.value = !1, g), (g) => {
          throw i.value = !1, g;
        });
      };
    };
  }
  const L = Ue(!1);
  L.withControlled = Ue(!0);
  function Xe(a, l) {
    const u = m.value.findIndex((V) => V.path === a && (Array.isArray(V.id) ? V.id.includes(l) : V.id === l)), f = m.value[u];
    if (!(u === -1 || !f)) {
      if (ne(() => {
        be(a, { mode: "silent", warn: !1 });
      }), f.multiple && f.fieldsCount && f.fieldsCount--, Array.isArray(f.id)) {
        const V = f.id.indexOf(l);
        V >= 0 && f.id.splice(V, 1), delete f.__flags.pendingUnmount[l];
      }
      (!f.multiple || f.fieldsCount <= 0) && (m.value.splice(u, 1), Vt(a), S(), delete p.value[a]);
    }
  }
  function h(a) {
    Y(p.value).forEach((l) => {
      l.startsWith(a) && delete p.value[l];
    }), m.value = m.value.filter((l) => !l.path.startsWith(a)), ne(() => {
      S();
    });
  }
  const k = {
    name: r,
    formId: n,
    values: d,
    controlledValues: he,
    errorBag: b,
    errors: $,
    schema: ee,
    submitCount: c,
    meta: je,
    isSubmitting: i,
    isValidating: s,
    fieldArrays: v,
    keepValuesOnUnmount: me,
    validateSchema: w(ee) ? de : void 0,
    validate: Ie,
    setFieldError: N,
    validateField: be,
    setFieldValue: I,
    setValues: oe,
    setErrors: B,
    setFieldTouched: Q,
    setTouched: bt,
    resetForm: xe,
    resetField: gt,
    handleSubmit: L,
    useFieldModel: un,
    defineInputBinds: sn,
    defineComponentBinds: dn,
    defineField: Ze,
    stageInitialValue: an,
    unsetInitialValue: Vt,
    setFieldInitialValue: Qe,
    createPathState: Ee,
    getPathState: z,
    unsetPathValue: we,
    removePathState: Xe,
    initialValues: pe,
    getAllPathStates: () => m.value,
    destroyPath: h,
    isFieldTouched: nn,
    isFieldDirty: rn,
    isFieldValid: ln
  };
  function I(a, l, u = !0) {
    const f = C(l), V = typeof a == "string" ? a : a.path;
    z(V) || Ee(V), ae(d, V, f), u && be(V);
  }
  function A(a, l = !0) {
    Y(d).forEach((u) => {
      delete d[u];
    }), Y(a).forEach((u) => {
      I(u, a[u], !1);
    }), l && Ie();
  }
  function oe(a, l = !0) {
    Be(d, a), v.forEach((u) => u && u.reset()), l && Ie();
  }
  function le(a, l) {
    const u = z(y(a)) || Ee(a);
    return E({
      get() {
        return u.value;
      },
      set(f) {
        var V;
        const j = y(a);
        I(j, f, (V = y(l)) !== null && V !== void 0 ? V : !1);
      }
    });
  }
  function Q(a, l) {
    const u = z(a);
    u && (u.touched = l);
  }
  function nn(a) {
    const l = z(a);
    return l ? l.touched : m.value.filter((u) => u.path.startsWith(a)).some((u) => u.touched);
  }
  function rn(a) {
    const l = z(a);
    return l ? l.dirty : m.value.filter((u) => u.path.startsWith(a)).some((u) => u.dirty);
  }
  function ln(a) {
    const l = z(a);
    return l ? l.valid : m.value.filter((u) => u.path.startsWith(a)).every((u) => u.valid);
  }
  function bt(a) {
    if (typeof a == "boolean") {
      ce((l) => {
        l.touched = a;
      });
      return;
    }
    Y(a).forEach((l) => {
      Q(l, !!a[l]);
    });
  }
  function gt(a, l) {
    var u;
    const f = l && "value" in l ? l.value : X(pe.value, a), V = z(a);
    V && (V.__flags.pendingReset = !0), Qe(a, C(f), !0), I(a, f, !1), Q(a, (u = l == null ? void 0 : l.touched) !== null && u !== void 0 ? u : !1), N(a, (l == null ? void 0 : l.errors) || []), ne(() => {
      V && (V.__flags.pendingReset = !1);
    });
  }
  function xe(a, l) {
    let u = C(a != null && a.values ? a.values : R.value);
    u = l != null && l.force ? u : Be(R.value, u), u = re(ee) && H(ee.cast) ? ee.cast(u) : u, ke(u, { force: l == null ? void 0 : l.force }), ce((f) => {
      var V;
      f.__flags.pendingReset = !0, f.validated = !1, f.touched = ((V = a == null ? void 0 : a.touched) === null || V === void 0 ? void 0 : V[y(f.path)]) || !1, I(y(f.path), X(u, y(f.path)), !1), N(y(f.path), void 0);
    }), l != null && l.force ? A(u, !1) : oe(u, !1), B((a == null ? void 0 : a.errors) || {}), c.value = (a == null ? void 0 : a.submitCount) || 0, ne(() => {
      Ie({ mode: "silent" }), ce((f) => {
        f.__flags.pendingReset = !1;
      });
    });
  }
  async function Ie(a) {
    const l = (a == null ? void 0 : a.mode) || "force";
    if (l === "force" && ce((g) => g.validated = !0), k.validateSchema)
      return k.validateSchema(l);
    s.value = !0;
    const u = await Promise.all(m.value.map((g) => g.validate ? g.validate(a).then((F) => ({
      key: y(g.path),
      valid: F.valid,
      errors: F.errors,
      value: F.value
    })) : Promise.resolve({
      key: y(g.path),
      valid: !0,
      errors: [],
      value: void 0
    })));
    s.value = !1;
    const f = {}, V = {}, j = {};
    for (const g of u)
      f[g.key] = {
        valid: g.valid,
        errors: g.errors
      }, g.value && ae(j, g.key, g.value), g.errors.length && (V[g.key] = g.errors[0]);
    return {
      valid: u.every((g) => g.valid),
      results: f,
      errors: V,
      values: j,
      source: "fields"
    };
  }
  async function be(a, l) {
    var u;
    const f = z(a);
    return f && (l == null ? void 0 : l.mode) !== "silent" && (f.validated = !0), f != null && f.validate ? f.validate(l) : (!f && ((u = l == null ? void 0 : l.warn) !== null && u !== void 0 ? u : !0) && process.env.NODE_ENV !== "production" && hn(`field with path ${a} was not found`), Promise.resolve({ errors: [], valid: !0 }));
  }
  function Vt(a) {
    Nt(pe.value, a);
  }
  function an(a, l, u = !1) {
    Qe(a, l), ae(d, a, l), u && ae(R.value, a, C(l));
  }
  function Qe(a, l, u = !1) {
    ae(pe.value, a, C(l)), u && ae(R.value, a, C(l));
  }
  async function Ot() {
    const a = w(ee);
    if (!a)
      return { valid: !0, results: {}, errors: {}, source: "none" };
    s.value = !0;
    const l = He(a) || re(a) ? await nr(a, d) : await rr(a, d, {
      names: U.value,
      bailsMap: Ye.value
    });
    return s.value = !1, l;
  }
  const on = L((a, { evt: l }) => {
    Un(l) && l.target.submit();
  });
  Rt(() => {
    k.validateSchema && k.validateSchema("silent");
  }), We(ee) && ie(ee, () => {
    var a;
    (a = k.validateSchema) === null || a === void 0 || a.call(k, "validated-only");
  }), ot(mt, k), process.env.NODE_ENV !== "production" && (sr(k), ie(() => Object.assign(Object.assign({ errors: b.value }, je.value), { values: d, isSubmitting: i.value, isValidating: s.value, submitCount: c.value }), Ae, {
    deep: !0
  }));
  function Ze(a, l) {
    const u = H(l) || l == null ? void 0 : l.label, f = z(y(a)) || Ee(a, { label: u }), V = () => H(l) ? l(ze(f, Le)) : l || {};
    function j() {
      var _;
      f.touched = !0, ((_ = V().validateOnBlur) !== null && _ !== void 0 ? _ : Te().validateOnBlur) && be(y(f.path));
    }
    function g() {
      var _;
      ((_ = V().validateOnInput) !== null && _ !== void 0 ? _ : Te().validateOnInput) && ne(() => {
        be(y(f.path));
      });
    }
    function F() {
      var _;
      ((_ = V().validateOnChange) !== null && _ !== void 0 ? _ : Te().validateOnChange) && ne(() => {
        be(y(f.path));
      });
    }
    const T = E(() => {
      const _ = {
        onChange: F,
        onInput: g,
        onBlur: j
      };
      return H(l) ? Object.assign(Object.assign({}, _), l(ze(f, Le)).props || {}) : l != null && l.props ? Object.assign(Object.assign({}, _), l.props(ze(f, Le))) : _;
    });
    return [le(a, () => {
      var _, q, K;
      return (K = (_ = V().validateOnModelUpdate) !== null && _ !== void 0 ? _ : (q = Te()) === null || q === void 0 ? void 0 : q.validateOnModelUpdate) !== null && K !== void 0 ? K : !0;
    }), T];
  }
  function un(a) {
    return Array.isArray(a) ? a.map((l) => le(l, !0)) : le(a);
  }
  function sn(a, l) {
    const [u, f] = Ze(a, l);
    function V() {
      f.value.onBlur();
    }
    function j(F) {
      const T = Ge(F);
      I(y(a), T, !1), f.value.onInput();
    }
    function g(F) {
      const T = Ge(F);
      I(y(a), T, !1), f.value.onChange();
    }
    return E(() => Object.assign(Object.assign({}, f.value), {
      onBlur: V,
      onInput: j,
      onChange: g,
      value: u.value
    }));
  }
  function dn(a, l) {
    const [u, f] = Ze(a, l), V = z(y(a));
    function j(g) {
      u.value = g;
    }
    return E(() => {
      const g = H(l) ? l(ze(V, Le)) : l || {};
      return Object.assign({ [g.model || "modelValue"]: u.value, [`onUpdate:${g.model || "modelValue"}`]: j }, f.value);
    });
  }
  const St = Object.assign(Object.assign({}, k), { values: vn(d), handleReset: () => xe(), submitForm: on });
  return ot(Mn, St), St;
}
function Or(e, t, n, r) {
  const o = {
    touched: "some",
    pending: "some",
    valid: "every"
  }, i = E(() => !G(t, w(n)));
  function s() {
    const v = e.value;
    return Y(o).reduce((d, m) => {
      const O = o[m];
      return d[m] = v[O]((p) => p[m]), d;
    }, {});
  }
  const c = qe(s());
  return mn(() => {
    const v = s();
    c.touched = v.touched, c.valid = v.valid, c.pending = v.pending;
  }), E(() => Object.assign(Object.assign({ initialValues: w(n) }, c), { valid: c.valid && !Y(r.value).length, dirty: i.value }));
}
function Sr(e, t, n) {
  const r = tn(), o = x(r), i = x(C(r));
  function s(c, v) {
    v != null && v.force ? (o.value = C(c), i.value = C(c)) : (o.value = Be(C(o.value) || {}, C(c)), i.value = Be(C(i.value) || {}, C(c))), v != null && v.updateFields && e.value.forEach((d) => {
      if (d.touched)
        return;
      const O = X(o.value, y(d.path));
      ae(t, y(d.path), C(O));
    });
  }
  return {
    initialValues: o,
    originalInitialValues: i,
    setInitialValues: s
  };
}
function kr(e, t) {
  return t ? {
    valid: e.valid && t.valid,
    errors: [...e.errors, ...t.errors]
  } : e;
}
const jr = yn({
  name: "vs-input",
  components: {
    vsIcon: kn,
    vsUpload: jn,
    vsAvatar: En,
    vsTelInput: Cn,
    vsButton: An,
    vsCalendar: wn
  },
  props: {
    modelValue: null,
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    rules: {
      type: [String, Object, Function],
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    note: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: "nope"
    },
    emptyOption: {
      type: Boolean,
      default: !1
    },
    maxlength: {
      type: Number,
      default: null
    },
    renderless: {
      type: Boolean,
      default: !1
    },
    options: {
      type: Array,
      default: () => []
    },
    isImageUpload: {
      type: Boolean,
      default: !1
    },
    size: {
      type: Number,
      default: 100
    },
    avatar: {
      type: [String, Boolean, FileList],
      default: ""
    },
    avatarName: {
      type: String,
      default: ""
    },
    parentClass: {
      type: String,
      default: ""
    }
  },
  emits: ["input", "keyup", "focus", "blur", "update:modelValue", "change"],
  setup(e, { emit: t }) {
    const {
      value: n,
      errorMessage: r,
      handleBlur: o,
      handleChange: i,
      errors: s,
      meta: c
    } = hr(e.name, e.rules, {
      initialValue: e.modelValue,
      validateOnValueUpdate: !1
    }), v = x();
    ie(() => e.modelValue, () => {
      n.value = e.modelValue;
    }, { deep: !0 });
    const d = (B) => {
      var b;
      o(B), t("blur", (b = B.target) == null ? void 0 : b.value);
    }, m = E(() => s.value.length === 0), O = E(() => {
      const B = {
        focus: (b) => {
          t("focus", b);
        },
        keyup: (b) => {
          t("keyup", b);
        },
        blur: (b) => {
          d(b), t("blur", b);
        },
        change: (b) => {
          const U = b.target.value.trim() || "";
          i(U), t("change", b);
        }
      };
      return r.value ? B.input = (b) => {
        const U = b.target.value.trim() || "";
        i(U), t("input", b);
      } : B.input = (b) => {
        var $;
        n.value = ($ = b.target) == null ? void 0 : $.value, t("input", b);
      }, B;
    }), p = x(null), S = [
      "button",
      "checkbox",
      "color",
      "file",
      "hidden",
      "image",
      "radio",
      "buttonSet",
      "range",
      "reset",
      "submit"
    ], N = E(() => S.includes(e.type) ? "" : `bg-surface h-8 border-b border-black border-opacity-40 border-1 hover:border-opacity-90 text-md text-on-surface focus:outline-none focus:border-primary
          ${e.type === "incremental" ? "opacity-50" : ""} 
          ${m.value ? "" : "!border-error"} 
          ${e.disabled ? "opacity-50" : ""}`);
    return {
      emit: t,
      innerInput: v,
      errorMessage: r,
      valid: m,
      validationListeners: O,
      meta: c,
      checkbox: p,
      getStyle: N,
      localValue: n
    };
  }
}), Er = ["for"], Cr = {
  key: 0,
  class: "inline-block"
}, Ar = { class: "flex items-center" }, wr = { class: "relative flex items-center" }, Ir = ["id", "disabled", "name", "checked"], _r = { class: "cursor-pointer ml-2" }, Nr = { key: 1 }, Fr = { class: "flex justify-between items-center" }, Pr = { class: "flex align-items-center rounded-xl overflow-hidden" }, Tr = ["name", "label", "value", "disabled", "data-chosen"], Mr = {
  key: 0,
  value: ""
}, Dr = ["value", "selected"], Rr = { key: 3 }, Br = {
  key: 4,
  class: "flex flex-col justify-center items-center hover:brightness-90"
}, $r = {
  key: 0,
  class: "-translate-y-3 text-center pointer-events-none text-primary w-80"
}, Ur = {
  key: 5,
  class: "-mt-5"
}, zr = {
  key: 6,
  class: "-mt-5"
}, Lr = ["readonly", "disabled", "type", "step", "name", "maxlength", "autocomplete", "placeholder", "value"], Wr = {
  key: 9,
  class: "pointer-events-none absolute top-0 left-0 text-primary text-xs translate-y-3 w-80"
}, qr = {
  key: 1,
  class: "bg-surface text-error text-xs rounded"
}, Hr = {
  key: 2,
  class: "text-sm opacity-80"
};
function Gr(e, t, n, r, o, i) {
  const s = Ce("vs-icon"), c = Ce("vs-button"), v = Ce("vs-upload"), d = Ce("vs-avatar"), m = Ce("vs-tel-input"), O = Ce("vs-calendar");
  return P(), M("div", {
    class: Ne(["my-5", e.parentClass])
  }, [
    e.renderless ? ge("", !0) : (P(), M("label", {
      key: 0,
      for: e.name,
      class: Ne(`floating-label relative w-full ${e.disabled ? "opacity-50" : ""} ${e.errorMessage ? "!text-error animate-shake" : ""}`)
    }, [
      e.type === "checkbox" ? (P(), M("div", Cr, [
        Ve("div", Ar, [
          Ve("div", wr, [
            bn(Ve("input", lt({
              type: "checkbox",
              ref: "checkbox",
              class: ["cursor-pointer appearance-none !h-6 !w-6 rounded-xl bg-primary-100 checked:bg-primary checked:border-transparent focus:outline-none", e.errorMessage ? "!text-error animate-shake" : ""]
            }, e.$attrs, {
              "onUpdate:modelValue": t[0] || (t[0] = (p) => e.localValue = p),
              id: e.name,
              disabled: e.disabled,
              name: e.name,
              checked: e.localValue,
              onChange: t[1] || (t[1] = (p) => e.$emit("update:modelValue", p.target.checked))
            }), null, 16, Ir), [
              [gn, e.localValue]
            ]),
            Fe(s, {
              class: "pointer-events-none absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2",
              name: "bi:check",
              color: "on-primary",
              size: 24
            })
          ]),
          Ve("div", _r, te(e.label), 1)
        ])
      ])) : e.type === "buttonSet" ? (P(), M("div", Nr, [
        Ve("div", Fr, [
          Ve("div", null, te(e.label), 1),
          Ve("div", Pr, [
            (P(!0), M(kt, null, jt(e.options, (p, S) => (P(), Vn(c, {
              key: p.id,
              class: Ne(["!rounded-none !outline-none", e.localValue !== p.id ? "bg-primary-900 bg-opacity-10" : ""]),
              kind: e.localValue === p.id ? p.color || "primary" : "",
              value: p.id,
              onClick: (N) => {
                e.localValue = p.id, e.$emit("update:modelValue", p.id);
              }
            }, {
              default: On(() => [
                Sn(te(p.name), 1)
              ]),
              _: 2
            }, 1032, ["class", "kind", "value", "onClick"]))), 128))
          ])
        ])
      ])) : e.type === "select" ? (P(), M("select", lt({
        key: 2,
        class: `custom-select w-full my-4 ${e.getStyle}`,
        ref: e.name,
        name: e.name,
        label: e.label,
        value: e.localValue,
        disabled: e.disabled
      }, Et(e.validationListeners, !0), {
        "data-chosen": e.localValue || "",
        onChange: t[2] || (t[2] = (p) => e.$emit("update:modelValue", p.target.value))
      }), [
        e.emptyOption ? (P(), M("option", Mr)) : ge("", !0),
        (P(!0), M(kt, null, jt(e.options, (p) => (P(), M("option", {
          key: p.id,
          value: p.id,
          selected: e.localValue === p.id
        }, te(p.name), 9, Dr))), 128))
      ], 16, Tr)) : e.type === "file" ? (P(), M("div", Rr, [
        Fe(v, { isImageUpload: e.isImageUpload }, null, 8, ["isImageUpload"])
      ])) : e.type === "avatar" ? (P(), M("div", Br, [
        Fe(d, {
          class: "mb-5",
          size: e.size,
          name: e.avatarName,
          avatar: e.avatar,
          editable: "",
          "onAvatar:upload": t[3] || (t[3] = (p) => {
            e.$emit("update:modelValue", p);
          })
        }, null, 8, ["size", "name", "avatar"]),
        e.label ? (P(), M("span", $r, te(e.label), 1)) : ge("", !0)
      ])) : e.type === "tel" ? (P(), M("div", Ur, [
        e.label ? (P(), M("span", {
          key: 0,
          class: Ne(["-translate-y-3 text-center text-sm pointer-events-none w-80 opacity-90", e.errorMessage ? "!text-error animate-shake" : ""])
        }, te(e.label), 3)) : ge("", !0),
        Fe(m, {
          ref: e.name,
          name: e.name,
          label: e.label,
          disabled: e.disabled,
          placeholder: e.label,
          modelValue: e.localValue,
          "onUpdate:modelValue": t[4] || (t[4] = (p) => e.localValue = p),
          error: !!e.errorMessage
        }, null, 8, ["name", "label", "disabled", "placeholder", "modelValue", "error"])
      ])) : ["date", "dateTime"].includes(e.type) ? (P(), M("div", zr, [
        Fe(O, {
          title: e.label,
          mode: e.type,
          forcedDates: e.localValue,
          "onDates:changed": t[5] || (t[5] = (p) => {
            e.localValue = p, e.$emit("update:modelValue", p);
          })
        }, null, 8, ["title", "mode", "forcedDates"])
      ])) : (P(), M("input", lt({
        key: 7,
        readonly: e.type === "incremental",
        disabled: e.disabled,
        class: `floating_input ${e.getStyle}`,
        type: e.type,
        ref: "innerInput",
        step: e.type == "number" ? "any" : "",
        name: e.name,
        maxlength: e.maxlength,
        autocomplete: e.autocomplete,
        placeholder: e.placeholder,
        value: e.localValue
      }, Et(e.validationListeners, !0), e.$attrs, {
        onInput: t[6] || (t[6] = (p) => e.$emit("update:modelValue", p.target.value))
      }), null, 16, Lr)),
      e.label && ["checkbox", "address", "file", "avatar", "tel", "buttonSet", "date", "dateTime"].indexOf(e.type) === -1 ? (P(), M("span", {
        key: 8,
        class: Ne([`${e.type === "address" ? "mt-3" : ""} ${e.errorMessage ? "!text-error animate-shake" : ""} ${e.type === "tel" ? "left-16" : "left-0"} ${e.placeholder ? "force-floating-label" : ""}`, "pointer-events-none text-base absolute -top-2 duration-300 w-full opacity-90"])
      }, te(e.label) + " " + te(e.type === "incremental" ? " (Automático)" : ""), 3)) : ["checkbox", "avatar", "tel", "buttonSet", "date", "dateTime"].indexOf(e.type) === -1 ? (P(), M("span", Wr, te(e.label), 1)) : ge("", !0)
    ], 10, Er)),
    e.errorMessage && e.meta.touched ? (P(), M("div", qr, te(e.errorMessage), 1)) : ge("", !0),
    e.note ? (P(), M("div", Hr, te(e.note), 1)) : ge("", !0)
  ], 2);
}
const ll = /* @__PURE__ */ In(jr, [["render", Gr], ["__scopeId", "data-v-f2f78e6d"]]);
export {
  nl as c,
  tl as d,
  rl as u,
  ll as v
};
//# sourceMappingURL=vsInput-DpVLmt1L.mjs.map
